//
// Module for the HIB Amount Detail Edit screen
//
rs.module("system_/configuration/hibamounts/edit",

    [],

    function () {

        function initialize(jsSelectors, codeValues) {
            var form = $.js(jsSelectors.form);

            var doubleAmountInput = form.js(jsSelectors.doubleAmountInput);
            var doubleAmountHiddenInput = form.js(jsSelectors.doubleAmountHiddenInput);
            var hibTierSelect = form.js(jsSelectors.hibTierSelect);

            hibTierSelect.on("change", disableAndClearDoubleAmount);

            function disableAndClearDoubleAmount() {
                var isTier3 = hibTierSelect.val() == codeValues.Tier3;

                doubleAmountInput.prop("disabled", isTier3);

                if (isTier3) {
                    doubleAmountInput.val("");
                    doubleAmountHiddenInput.val("");
                }
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);